import { pipe, propEq } from 'ramda';
import { StateStatus } from '@alycecom/utils';

import { IRootState } from '../../../../store/root.types';

import { addressAdapter, TAddressState } from './address.reducer';

const getAddressState = (state: IRootState): TAddressState => state.recipient.address;

const selectors = addressAdapter.getSelectors(getAddressState);

export const getIsAddressesLoading = pipe(getAddressState, propEq('status', StateStatus.Pending));
export const getIsAddressesLoaded = pipe(getAddressState, propEq('status', StateStatus.Fulfilled));
export const getAddresses = selectors.getAll;
export const getAddressesMap = selectors.getEntities;
export const getAddressesIds = selectors.getIds;
